// extracted by mini-css-extract-plugin
module.exports = {"video":"YoutubeEmbed_video__1nBMy"};